import createStore from "astrid-helpers/src/createStore";
export const [getScale, setScale, useScale, onScale] = createStore(2);
//# sourceMappingURL=scale.js.map